export default "__VITE_ASSET__37e4ef24__"